// Function to Add days to current date
const addDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
};

/** Disable Sundays */
const tileDisabled = ({ date }) => {
  return date.getDay() === 0;
};

export { addDays, tileDisabled };
